<script setup>
import { onMounted, computed, watchEffect, defineProps } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import { authHeader } from "@/helpers/authservice/auth-header";

const props = defineProps({
  refetch_button: {
    type: Boolean,
    default: false,
  },
  clean_input: {
    type: Boolean,
    default: false,
  },
  reg_type_auto: {
    type: Boolean,
    default: true,
  },
  enabled_input: {
    type: Boolean,
    default: true,
  },
});

onMounted(() => {
  is_valid_registration_number.value = {
    is_valid: false,
    msg: "Invalid",
  };

  if (props.clean_input) {
    input_registration_number.value = "";
  }

  // if (!props.reg_type_auto) {
  //   selected_registration_type.value = 1;
  // }

  getRegistrationTypeList();
  getMotorVehicleTypeList();

  watchEffect(() => {
    if (
      input_registration_number.value ||
      selected_registration_type.value ||
      selected_motor_vehicle_type.value
    ) {
      if (input_registration_number.value != null) {
        validateRegistrationNumber();
      }
    }
  });
});

const store = useStore();

const traffic_record = computed(
  () => store.state.trafficRecordComponent.traffic_record
);
const registration_type_list = computed(
  () => store.state.trafficRecordComponent.registration_type_list
);
const motor_vehicle_type_list = computed(
  () => store.state.trafficRecordComponent.motor_vehicle_type_list
);
const input_registration_number = computed({
  get: () => store.state.trafficRecordComponent.input_registration_number,
  set: (val) =>
    store.commit("trafficRecordComponent/SET_INPUT_REGISTRATION_NUMBER", val),
});
const selected_registration_type = computed({
  get: () => store.state.trafficRecordComponent.selected_registration_type,
  set: (val) =>
    store.commit("trafficRecordComponent/SET_SELECTED_REGISTRATION_TYPE", val),
});
const selected_motor_vehicle_type = computed({
  get: () => store.state.trafficRecordComponent.selected_motor_vehicle_type,
  set: (val) =>
    store.commit("trafficRecordComponent/SET_SELECTED_MOTOR_VEHICLE_TYPE", val),
});

const is_valid_registration_number = computed({
  get: () => store.state.trafficRecordComponent.is_valid_registration_number,
  set: (val) =>
    store.commit(
      "trafficRecordComponent/SET_IS_VALID_REGISTRATION_NUMBER",
      val
    ),
});

const getRegistrationTypeList = () =>
  store.dispatch("trafficRecordComponent/getRegistrationTypeList");
const getMotorVehicleTypeList = () =>
  store.dispatch("trafficRecordComponent/getMotorVehicleTypeList");

const validateRegistrationNumber = () => {
  const l_o_n = letterOrNumber();
  switch (selected_registration_type.value) {
    case 1:
      validatePlate(l_o_n);
      break;
    case 2:
      validateCS(l_o_n);
      break;
    case 3:
      validateMVFile(l_o_n);
      break;
    default:
      is_valid_registration_number.value = {
        is_valid: false,
        msg: "Select Registration Type",
      };
  }
};

const inputPlateCandidate = (candidate) => {
  input_registration_number.value = candidate;
  uppercase();
};

// const chunk = (arr, size) =>{
//     let chunks = []
//     for (let i = 0; i < arr.length; i += size) {
//       chunks.push(arr.slice(i, i + size))
//     }
//     return chunks
// }

const validatePlate = (l_o_n) => {
  if (
    selected_motor_vehicle_type.value == 12 ||
    selected_motor_vehicle_type.value == 17
  ) {
    switch (l_o_n) {
      case "NNNLLL":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      case "LLNNNNN":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      case "NNNNLL":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      case "LLNNNN":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      default:
        is_valid_registration_number.value = {
          is_valid: false,
          msg: "This is not a valid plate number",
        };
    }
  } else {
    switch (l_o_n) {
      case "LLLNNN":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      case "LLLNNNN":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      case "LLLNN":
        is_valid_registration_number.value = {
          is_valid: true,
          msg: "Valid",
        };
        break;
      default:
        is_valid_registration_number.value = {
          is_valid: false,
          msg: "This is not a valid plate number",
        };
    }
  }
};

const validateCS = (l_o_n) => {
  switch (l_o_n) {
    case "LLNNNN":
      is_valid_registration_number.value = {
        is_valid: true,
        msg: "Valid",
      };
      break;
    case "LNLNNN":
      is_valid_registration_number.value = {
        is_valid: true,
        msg: "Valid",
      };
      break;
    default:
      is_valid_registration_number.value = {
        is_valid: false,
        msg: "This is not a valid conduction sticker",
      };
  }
};

const validateMVFile = (l_o_n) => {
  switch (l_o_n) {
    case "NNNNNNNNNNNNNNN":
      is_valid_registration_number.value = {
        is_valid: true,
        msg: "Valid",
      };
      break;
    case "NNNNNNNNNNNNNNL":
      is_valid_registration_number.value = {
        is_valid: true,
        msg: "Valid",
      };
      break;
    default:
      is_valid_registration_number.value = {
        is_valid: false,
        msg: "This is not a valid MV file No.",
      };
  }
};

const letterOrNumber = () => {
  const reg_no = input_registration_number.value.toString();
  const reg_no_array = reg_no.split("");
  let l_o_n = "";

  reg_no_array.forEach((value) => {
    if (value.length === 1 && value.match(/[a-zA-Z]/i)) {
      l_o_n += "L";
    } else if (value.length === 1 && value.match(/[0-9]/i)) {
      l_o_n += "N";
    } else {
      l_o_n += "X";
    }
  });

  return l_o_n;
};

const uppercase = () => {
  input_registration_number.value =
    input_registration_number.value.toUpperCase();
};

const refetchMvFileRecord = async () => {
  if (!is_valid_registration_number.value.is_valid) {
    return Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please enter a valid Registration Number.",
    });
  }

  const confirm = await Swal.fire({
    icon: "warning",
    title: "Continue?",
    text: "This will update the registration number and fetch LTO record, do you want to proceed?",
    showCancelButton: true,
    confirmButtonText: "Proceed",
  });

  if (!confirm.isConfirmed) {
    return;
  }

  try {
    store.dispatch("globals/loading", null, { root: true });

    const inputs = {
      registration_type_id: selected_registration_type.value,
      motor_vehicle_type_id: selected_motor_vehicle_type.value,
      registration_number: input_registration_number.value,
    };

    try {
      await axios.post(
        `/traffic_record_component/mv_file_record/refetch/${traffic_record.value.id}`,
        inputs,
        {
          headers: authHeader(),
        }
      );

      const baseUrl = window.location.origin + window.location.pathname;

      window.history.replaceState(null, "", baseUrl);
      window.location.reload();
    } catch (message) {
      console.log(message.response.data.message);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: message.response.data.message,
      });
      store.dispatch("globals/loaded", null, { root: true });
    }

    store.dispatch("globals/loaded", null, { root: true });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "There was an error in connecting to API. Please try again.",
    });
    store.dispatch("globals/loaded", null, { root: true });
  }
};

const loading = computed(() => store.state.globals.loading);
</script>

<template>
  <div class="col-md-12 col-lg-6 col-xl-6 mb-0">
    <b-overlay :show="loading">
      <div class="card">
        <div class="card-body overflow-auto">
          <table class="table table-bordered table-sm table-light m-0">
            <tbody>
              <tr>
                <th colspan="3" class="text-center">Registration Details</th>
              </tr>
              <tr>
                <td class="text-center">
                  <label>Registration Type</label>
                  <select
                    required
                    class="form-select"
                    v-model="selected_registration_type"
                  >
                    <option :value="null">-Select Reg Type-</option>
                    <template
                      v-for="option in registration_type_list"
                      :key="option.id"
                    >
                      <option :value="option.id">
                        {{ option.name }}
                      </option>
                    </template>
                  </select>
                </td>
                <td class="text-center">
                  <label>Registration Number</label>
                  <input
                    @input="uppercase"
                    required
                    type="text"
                    class="form-control"
                    v-model="input_registration_number"
                    :disabled="!enabled_input"
                  />
                  <small
                    :class="[
                      is_valid_registration_number.is_valid
                        ? 'text-success'
                        : 'text-danger',
                    ]"
                    >{{ is_valid_registration_number.msg }}</small
                  >
                </td>
                <td class="text-center">
                  <label>Motor Vehicle Type</label>
                  <select
                    required
                    class="form-select"
                    v-model="selected_motor_vehicle_type"
                  >
                    <template
                      v-for="option in motor_vehicle_type_list"
                      :key="option.id"
                    >
                      <option :value="option.id">
                        {{ option.name }}
                      </option>
                    </template>
                  </select>
                </td>
              </tr>
              <tr v-if="props.refetch_button">
                <td colspan="3">
                  <div
                    style="
                      max-height: 300px;
                      overflow-x: hidden;
                      overflow-y: auto;
                    "
                  >
                    <div class="row">
                      <label
                        v-if="
                          traffic_record.registration_number !=
                            traffic_record.anpr_plate_number ||
                          traffic_record.anpr_plate_candidates
                        "
                        class="text-center"
                        >Plate Number Candidates</label
                      >
                      <div class="col-md-4">
                        <ul>
                          <li>
                            <a
                              href="javascript:void(0);"
                              @click="
                                inputPlateCandidate(
                                  traffic_record.registration_number
                                )
                              "
                              >{{ traffic_record.registration_number }}</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div
                        v-if="
                          traffic_record.registration_number !=
                            traffic_record.anpr_plate_number &&
                          traffic_record.anpr_plate_number != '' &&
                          traffic_record.anpr_plate_number
                        "
                        class="col-md-4"
                      >
                        <ul>
                          <li>
                            <a
                              href="javascript:void(0);"
                              @click="
                                inputPlateCandidate(
                                  traffic_record.anpr_plate_number
                                )
                              "
                              >{{ traffic_record.anpr_plate_number }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- <div class="row">
                        <div v-for="(group, index) in chunk(traffic_record.anpr_plate_candidates, 3)" :key="index" class="col-md-4">
                          <ul>
                            <li v-for="item in group" :key="item.id">
                              <a href="javascript:void(0);" @click="inputPlateCandidate(item.plate_number)">{{ item.plate_number }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>-->
                  </div>
                </td>
              </tr>
              <tr v-if="props.refetch_button">
                <td colspan="3" class="text-center">
                  <button
                    type="button"
                    class="btn btn-info btn-sm"
                    @click="refetchMvFileRecord"
                  >
                    Get Record
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<style scoped>
select option {
  font-size: 14px;
}
select option.article {
  font-size: 10px;
}
.no-wrap {
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
td {
  padding: 5px;
}
</style>
